export function invokeNativeFunctionByIFrame(url) {
  let hiddenArea = document.getElementById("hiddenArea"),
    hiddenIframe
  hiddenIframe = document.createElement("iframe")
  hiddenIframe.style.display = "none"
  hiddenArea.appendChild(hiddenIframe)
  hiddenIframe.src = url

  setTimeout(function() {
    // hiddenIframe.remove()
    hiddenArea.removeChild(hiddenIframe)
  }, 5000)
}

export function quanShare(picUrl) {
  const params = {
    type: "websharephoto",
    sharePath: picUrl,
    shareType: "TimeLine/Qzone"
  }
  const args = encodeURIComponent(JSON.stringify(params))
  const url = "uniwebview://webview?funcname=SetCommonThing&args=" + args
  console.log(url)
  invokeNativeFunctionByIFrame(url)
}

export function friendShare(picUrl) {
  const params = {
    type: "websharephoto",
    sharePath: picUrl,
    shareType: "Session"
  }
  const args = encodeURIComponent(JSON.stringify(params))
  const url = "uniwebview://webview?funcname=SetCommonThing&args=" + args
  console.log(url)
  invokeNativeFunctionByIFrame(url)
}

export function jumpGameSence(id) {
  var params = {
    type: "JumpForm",
    EntryId: id.toString()
  }
  var args = encodeURIComponent(JSON.stringify(params))
  var url = "uniwebview://webview?funcname=SetCommonThing&args=" + args
  console.log(url)
  invokeNativeFunctionByIFrame(url)
}
